import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ReorderRule, ReorderRuleCreate, ReorderRuleFilter } from '../data/reorderRule';

export function createReorderRuleService(client: AxiosInstance) {
  return createCrudService<ReorderRule, ReorderRuleCreate, ReorderRuleFilter>(
    client,
    '/purchase/ReorderRule',
    'id',
  );
}

export type ReorderRuleService = CrudService<ReorderRule, ReorderRuleCreate, ReorderRuleFilter>;
